import { ca } from '@cian/analytics';

export function trackPanoramaClose(objectType?: string) {
  ca('eventSite', {
    action: 'panorama',
    category: 'Infrastructure',
    label: 'close_show_sopr',
    name: 'oldevent',
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      extra: {
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
